import { SelectItem } from "primeng/api";

export class countryCodeList {
    id: number = null;
    value: SelectItem = null;
}

export class editLoginData_country {
    country_id: number = null;
    country_codes: countryCodeList[] = [];
}

export class editMedProfLoginData extends editLoginData_country {
    has_verified_email: boolean = false;
    e_email: string = "";
    has_verified_phone: boolean = false;
    country_phone_code: string = "";
    primary_contact_number: string = "";
}